import { render, staticRenderFns } from "./CrearOT.vue?vue&type=template&id=586e0bc6&lang=pug"
import script from "./CrearOT.vue?vue&type=script&lang=js"
export * from "./CrearOT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports